import React, { useContext, useEffect, useState } from "react";
import MobileField from "../../Utils/BasicComponents/MobileField";
import { MyContext } from "../../context/Context";
import Banner from "../../Utils/Banner/Banner";
import { useNavigate } from "react-router-dom";
import AuthBtn from "../../Utils/AuthBtn/AuthBtn";
import axios from "axios";
import { urlLinks } from "../../UrlLinks";
import { AuthContext } from "../../services/AuthProvider";

const LoginPage = () => {
  const {
    checkMobileNumber,
    handleOtpGeneration,
    navigatePage,
    getWorkerDetails,
  } = useContext(AuthContext);
  const { mobileNumber, setRoleType } = useContext(MyContext);
  const [errorMsg, setErrorMsg] = useState("");
  const navigate = useNavigate();

  const checkAccount = async () => {
    setErrorMsg("");
    if (!mobileNumber || (mobileNumber && String(mobileNumber).length === 0)) {
      setErrorMsg("Kindly fill the phone number");
      return;
    } else {
      try {
        const response = await axios.get(
          `${urlLinks.baseUrl}/user/${urlLinks.checkUserStatus}?phone_number=${mobileNumber}&user_id=0`
        );
        if (
          response.data.code === 1000 &&
          response.data.response.user_role === 4
        ) {
          localStorage.setItem("userId", response.data.response.user_id);
          setRoleType(response.data.response.user_role);
          /**----------- removed cognito authentication -----------------*/
          // let checkStatus = await checkMobileNumber();
          // if (checkStatus) {
          //   navigate("/password");
          // } else {
          //   handleOtpGeneration();
          // }
          /**----------- XXXXXXXXXXXXXXXXXXXXXXXXXXXXXX -----------------*/

          await getWorkerDetails();
        } else {
          setErrorMsg("Please contact admin for your OkayGo account");
          return;
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  useEffect(() => {
    navigatePage === "otpVerify" && navigate("/otp-verify");
    navigatePage === "taskPage" && navigate("/task-page");
  }, [navigatePage]);

  return (
    <section className="w-full h-full">
      <Banner heading={"Largest gig platform"} />
      <MobileField textField={"Enter your mobile number"} errorMsg={errorMsg} />
      <AuthBtn clickFunction={checkAccount} />
    </section>
  );
};

export default LoginPage;
